/**
 * Fingerprinting domain route constants
 * Centralized route definitions to avoid hardcoded strings throughout the app
 */

import type { DomainName } from '@shared/api/api-factory'

export const FINGERPRINTING_DOMAIN: DomainName = 'fingerprinting'

const BASE = '/fingerprinting'

export const FINGERPRINTING_ROUTES = {
  // Base
  BASE,
  
  // Login
  LOGIN: `${BASE}/login`,
  FORGOT_PASSWORD: `${BASE}/forgot-password`,
  RESET_PASSWORD: `${BASE}/reset-password`,
  CONFIRM_DOB: `${BASE}/confirm-dob`,

  // Client routes
  CLIENT: {
    BASE: `${BASE}/client`,
    APPLICATION: `${BASE}/client/application`,
    APPLICATION_DETAIL: (applicationId: string)=>  `${BASE}/client/application/${applicationId}`,
    APPLICATION_DOCUMENTS: (applicationId: string)=>  `${BASE}/client/application/${applicationId}/documents`,
    APPLICATION_INSTRUCTIONS: (applicationId: string)=> `${BASE}/client/application/${applicationId}/instructions`,
    INVOICE: `${BASE}/client/invoice`,
    E_SIGNATURE: `${BASE}/client/e-signature`,
    CHANGE_PASSWORD: `${BASE}/client/change-password`,
  },
  
  // Staff routes
  STAFF: {
    BASE: `${BASE}/staff`,
    APPLICATION: `${BASE}/staff/application`,
    APPLICATION_DETAIL: (applicationId: string)=>  `${BASE}/staff/application/${applicationId}`,
    APPLICATION_DOCUMENTS: (applicationId: string)=>  `${BASE}/staff/application/${applicationId}/documents`,
    APPLICATION_INTERNAL_DOCUMENTS: (applicationId: string)=> `${BASE}/staff/application/${applicationId}/internal-documents`,
    APPLICATION_MANUAL_CREATE: `${BASE}/staff/application/manual/create`,
    DOCUMENT: `${BASE}/staff/document`,
    DOCUMENT_DETAIL: `${BASE}/staff/document/$applicationTypeCode`,
    MESSAGE_TEMPLATE: `${BASE}/staff/message-template`,
    CHANGE_PASSWORD: `${BASE}/staff/change-password`,
    STAFF_MANAGEMENT: `${BASE}/staff/staff-management`,
    AUDIT_LOG: `${BASE}/staff/audit-log`,
  },
} as const

// Helper to build routes with params
export const buildRoute = {
  staffApplicationDetail: (applicationId: string | number) => 
    `${BASE}/staff/application/${applicationId}`,
  staffApplicationDocuments: (applicationId: string | number) => 
    `${BASE}/staff/application/${applicationId}/documents`,
  staffApplicationInternalDocuments: (applicationId: string | number) =>
    `${BASE}/staff/application/${applicationId}/internal-documents`,
  staffDocumentDetail: (applicationTypeCode: string) => 
    `${BASE}/staff/document/${applicationTypeCode}`,
  clientApplicationDetail: (applicationId: string | number) => 
    `${BASE}/client/application/${applicationId}`,
  clientApplicationDocuments: (applicationId: string | number) => 
    `${BASE}/client/application/${applicationId}/documents`,
  clientApplicationInstructions: (applicationId: string | number) => 
    `${BASE}/client/application/${applicationId}/instructions`,
}
